<div class="main-modal-container" 
     (touchstart)="onTouchStart($event)" 
     (touchend)="onTouchEnd($event)"
     (mousedown)="onMouseDown($event)"
     (mouseup)="onMouseUp($event)">
  
  <span class="close-x" [mat-dialog-close]="true">×</span>

  <div class="info-overlay top">
    <p class="txt-titulo">{{titulo}}</p>
  </div>

  <div class="content-wrapper">
    
    <button class="nav-btn left" *ngIf="gallery.length > 1" (click)="changeImg(-1)">
        <img class="arrow-carrousel" src="./assets/img/arrow-carrousel2-left.png" alt="Left Arrow">
    </button>

    <div class="img-frame">
      <img *ngIf="image.type == 'Imagen'" [src]="image.path" onerror="this.src='./assets/img/default.png'" class="full-img-view" />
      <iframe  *ngIf="image.type == 'Video (YouTube)'"  [style.height]="'100%'"
                [src]="image.safeUrl"  title="YouTube video player"  frameborder="0" 
             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  allowfullscreen>
          </iframe>
    </div>

    <button type="button" class="nav-btn right" *ngIf="gallery.length > 1" (click)="changeImg(1)">
      <img class="arrow-carrousel" src="./assets/img/arrow-carrousel2-right.png" alt="Right Arrow">
    </button>

  </div>

  <p *ngIf="image?.title" class="txt-titulo image-title mobile-image-title quicksand-bold">{{image.title}}</p>

  <div class="mobile-gallery-controls">
    <button type="button" class="nav-btn mobile-nav-btn" (click)="changeImg(-1)" aria-label="Imagen anterior">
      <img class="arrow-carrousel" src="./assets/img/arrow-carrousel2-left.png" alt="">
    </button>
    <p class="txt-contador mobile-counter">{{image.position + 1}} de {{gallery.length}}</p>
    <button type="button" class="nav-btn mobile-nav-btn" (click)="changeImg(1)" aria-label="Imagen siguiente">
      <img class="arrow-carrousel" src="./assets/img/arrow-carrousel2-right.png" alt="">
    </button>
  </div>

  <div class="info-overlay bottom">
    <p *ngIf="image?.title" class="txt-titulo image-title quicksand-bold">{{image.title}}</p>
    <p class="txt-contador">{{image.position + 1}} de {{gallery.length}}</p>
  </div>
</div>
